export default __webpack_public_path__ + "static/media/lightSensorActive.c99ae21e.svg";